import { createSelector, createSlice } from '@reduxjs/toolkit';
export const MARKETING_STATE_NAMESPACE = 'marketing';
export const marketingInitialState = {
    partnerId: null,
    marker: null,
    marker2: null,
    marker3: null,
    marker4: null,
    srcsale: null,
};
const marketingSlice = createSlice({
    name: MARKETING_STATE_NAMESPACE,
    initialState: marketingInitialState,
    reducers: {
        setMarketingParams: (state, action) => ({
            ...state,
            ...action.payload,
        }),
    },
});
export const marketingActions = marketingSlice.actions;
export const marketingReducer = marketingSlice.reducer;
const marketingStateSelector = (state) => state[MARKETING_STATE_NAMESPACE];
export const marketingParamsSelector = createSelector(marketingStateSelector, (marketingParams) => marketingParams);
